export const enum Status {
  Available = 'available',
  Unavailable = 'not_available',
  Partially = 'partially_available',
  Skip = 'already_updated',
}

export const statusOptions = [
  {
    value: Status.Available,
    label: 'Available (:dates)',
    labelMobile: 'Available (:dates)',
  },
  {
    value: Status.Unavailable,
    label: 'Not available (:dates)',
    labelMobile: 'Not available',
  },
  {
    value: Status.Partially,
    label: 'Partially available',
    labelMobile: 'Partially available',
  },
];
